<template>
  <div class="cardBox" :style="{ backgroundImage: 'url(' + bgimg + ')' }">
    <div class="message">
      <img
        :src="item.avatar ? item.avatar : DEFAULT_AVATAR"
        alt=""
        class="avatrImg"
      />
      <div style="width: 300px">
        <h1 class="textOverflow">{{ item.name }}</h1>
        <small class="textOverflow">{{ item.job }}</small>
        <span class="textOverflow"> {{ item.industry | industryFormat(LOCALE)}}</span>
      </div>
    </div>
    <p class="dsc text_overflow_2" :title="item.company">{{ item.company }}</p>
    <div class="lianxifanshi">
        <div>
          <img :src="phoneImg" alt="" />
            <span class="tel textOverflow">{{item.mobile | textFormat}}</span>
        </div>
        <div>
          <img :src="emailImg" alt="" />
          <span class="textOverflow">{{item.email | textFormat}}</span>
        </div>
        <div class="addressbox">
          <img class="addressimg" :src="location_png" alt="" />
        <span class="add" :title="getTitle(item)">{{item.country|countryCityFormat(item.region_en,item.region_zh,LOCALE)}}{{item.address=='-'?"":item.address}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { countryCityFormat  } from '@/basePlugins/filters'
export default {
  props: {
    item: {
      type: Object,
      default: function () {
        return {
          job: "ZHANGJIAGANG HAOHUA INTERNATIONAL FREIGHT FORWARDERS CO., LTD",
          avatar: "",
          status: "",
          name: "Rico Balingcongan",
          company: "Customer Service Manager",
          industry: "Logistics Supplier - Freight Forwarder",
          country: "Pampanga",
          city: "Philippines",
          address: "7 Gongzhuan Road, Xihu District",
          mobile: "15838061196",
          email: "15838061196@163.com",
        };
      },
    },
  },
  methods:{
    getTitle(item){
      return `${countryCityFormat(item.country,item.region_en, item.region_zh, this.LOCALE)} ${item.address=="-"?"":item.address}`
    },
  },
  data() {
    return {
      // bgimg: "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/expo/bg_blue.png",
      phoneImg:
        "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/phone.png",
      emailImg:
        "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/email.png",
      location_png: "https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/address.png",
    };
  },
  computed:{
    bgimg(){
      if(this.PJSource === 7){
        return `https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/siffa7.png`
      }else if(this.PJSource === 12){
        return `https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/trf12.png`
      }else if(this.PJSource === 13){
        return `https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/scb13.png`
      }else if(this.PJSource === 14){
        return `https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/qlc14.png`
      }else if(this.PJSource === 16){
        return `https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/lys16.png`
      }else if(this.PJSource === 18){
        return `https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/MPA18.png`
      }else if(this.PJSource === 19){
        return `https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/jbd19.png`
      }else if(this.PJSource === 20){
        return `https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/common/GBK20.png`
      }else{
        return `https://attached-file.oss-cn-shanghai.aliyuncs.com/ailaworldImgs/expo/bg_blue.png`
      }
    }
  }
};
</script>
<style lang="less" scoped>
.cardBox {
  height: 240px;
  background-size: contain;
  background-repeat: no-repeat;
  padding: 10px 20px;
  .message {
    height: 80px;
    display: flex;
    img {
      width: 80px;
      height: 80px;
    }
    div {
      padding-left: 16px;
      display: flex;
      flex-direction: column;
      width: 100%;
      h1 {
        height: 24px;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
        line-height: 24px;
      }
      small {
        height: 22px;
        font-size: 12px;
        font-weight: 400;
        color: #a6d1ff;
        line-height: 22px;
      }
      span {
        height: 24px;
        font-size: 12px;
        font-weight: 400;
        color: #f4faff;
        line-height: 24px;
      }
    }
  }
  .dsc {
    margin-top: 10px;
    margin-bottom: 10px;
    width: 376px;
    height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    overflow: hidden;
  }
  .tel_email {
    display: flex;
    justify-content: space-between;
    div {
      display: flex;
      align-items: center;
      img {
        padding-right: 9px;
      }
      .tel {
        width: 102px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
      }
      .email {
        width: 165px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
      }
    }
  }
  .address {
    margin-top: 12px;
    display: flex;
    align-items: center;
    img {
      padding-right: 9px;
    }
    div {
      width: 100%;
      height: 22px;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 22px;
      overflow: hidden;
      white-space: nowrap !important;
      text-overflow: ellipsis;
    }
  }
  .avatrImg {
    border-radius: 50%;
  }
}

.lianxifanshi {
  div {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    img {
      width: 14px;
      margin-right: 7px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
    }
    .add {
      width: 345px;
      // height: 38px;
      word-break:break-all;
      display:-webkit-box;/**对象作为伸缩盒子模型展示**/
      -webkit-box-orient:vertical;/**设置或检索伸缩盒子对象的子元素的排列方式**/
      -webkit-line-clamp:1;/**显示的行数**/
      overflow:hidden;/**隐藏超出的内容**/
    }
  }
}
</style>